import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MineTokenDto } from '../../models/mine/mine-token-dto';

@Injectable({
  providedIn: 'root'
})
export class MineEventService {
  private selectedMineSource = new BehaviorSubject<MineTokenDto | null>(null);
  selectedMine$ = this.selectedMineSource.asObservable();
  setSelectedMine(mine: MineTokenDto): void {
    this.selectedMineSource.next(mine);
  }
  getSelectedMine(): MineTokenDto | null {
    return this.selectedMineSource.value;
  }
}
